export const REVIEWS_REPLY_STATUS = {
  OK: 1,
  PROCESSING: 2,
  ERROR: 3
};
